import { AuthenticationPageExtensions } from '@ayocore/platform/identity/client/components/AuthenticationPageExtensions';
import { TelegramBindingCard } from '../components/TelegramBindingCard';

/**
 * Регистрирует расширение Telegram для страницы профиля пользователя.
 * Добавляет карточку управления личной Telegram-привязкой.
 *
 * Вызывается один раз из bootstrap.ts при старте приложения.
 */
export function registerTelegramIdentityExtension(): void {
  AuthenticationPageExtensions.profileCards.register(() => <TelegramBindingCard />);
}
